<form class="mt-5"
      [formGroup]="form"
      (ngSubmit)="addSupplementLink()">

  <div class="formgrid grid">

    <div class="field col-12 mb-4">
      <label for="link"
             class="font-bold sc-required-input"
             i18n>Link</label>
      <input scValidatable
             id="link"
             type="text"
             pInputText
             formControlName="link"
             placeholder="Enter link"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-12">
      <label class="font-bold sc-required-input"
             i18n>Description</label>
      <editor formControlName="description"
              scValidatable
              scLabelText="Description"
              i18n-scLabelText
              placeholder="Add description for link"
              i18n-placeholder
              class="w-full">
      </editor>
    </div>
  </div>

  <p-button scSubmitButton
            [requestInProcess]="requestInProcess"
            class="flex justify-content-center mt-3"
            label="Save"
            i18n-labe>
  </p-button>
</form>